// extracted by mini-css-extract-plugin
module.exports = {"Component":"CustomerServiceHistoryTable_Component__32YbX"};